(function () {
  function boot(root) {
    if (!root || root.getAttribute('data-rl-ready') === 'true') return;
    root.setAttribute('data-rl-ready', 'true');

    var url = root.getAttribute('data-url');
    if (!url || !window.fetch) return;
    if (root.querySelector('.cl__card')) return;

    fetch(url)
      .then(function (res) {
        if (!res.ok) throw new Error('recommendations-failed');
        return res.text();
      })
      .then(function (html) {
        var wrap = document.createElement('div');
        wrap.innerHTML = html;
        var next = wrap.querySelector('[data-rl]');
        if (!next || !next.querySelector('.cl__card')) {
          root.remove();
          return;
        }
        root.replaceWith(next);
        boot(next);
      })
      .catch(function () {
        root.remove();
      });
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-rl]'), boot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
